var Emitter = require('client/lib/emitter')
var modalTemplate = require('*views/partials/materialize-modal')

module.exports = class MaterializeModal extends Emitter {
  constructor(options) {
    super()

    this.options = options
    this.$view = $(modalTemplate(options)).appendTo(document.body)
    this.$view.find('.save').on('click', this.save.bind(this))
    app.on('should-close-modal', () => {
      this.close()
    })
  }

  open() {
    this.$view.openModal({
      opacity: 0.2,
      'starting_top': '0',
      'ending_top': '0',
      complete: this.closeComplete.bind(this)
    })
    return this
  }

  close() {
    this.$view.closeModal({
      complete: this.closeComplete.bind(this)
    })
    return this
  }

  save(e) {
    e && e.preventDefault()
    this.trigger('save')
  }

  closeComplete() {
    if (this.options.complete) {
      this.options.complete()
    } else {
      this.$view.remove()
      $('.lean-overlay').remove()
      this.trigger('closed')
    }
  }
}
